// extracted by mini-css-extract-plugin
export default {"link":"_14mt88DiF6"};
    if(module.hot) {
      // 1623933155716
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  